import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface ClassDistribution {
  className: string;
  classId: string;
  studentCount: number;
}

export interface StudentDistribution {
  id: string;
  name: string;
  studentCount: number;
  studioId: string;
  classes: Array<ClassDistribution>;
  studentPercent: number;
}

interface StudentDistributionResponse {
  result: Array<StudentDistribution>;
  totalCount: number;
}

export interface GetStudentDistributionParams {
  sessionId: string;
  groupBy: 'className' | 'groupName';
}

export const getStudentDistributionAPI = async (
  params: GetStudentDistributionParams,
) => {
  const response = await baseAPI.get<StudentDistributionResponse>(
    `/dashboard/student-distribution/class/${params.sessionId}`,
    {
      params: {
        groupBy: params.groupBy,
      },
    },
  );
  return response.data;
};

export const getStudentDistributionQueryOptions = (
  params: GetStudentDistributionParams,
) =>
  queryOptions({
    queryKey: [KEYS.STUDENT_DISTRIBUTION, params],
    queryFn: () => getStudentDistributionAPI(params),
  });

export const useGetStudentDistribution = (
  params: GetStudentDistributionParams,
) => {
  return useQuery(getStudentDistributionQueryOptions(params));
};
